import React from "react";
import { cx } from "./utils";

const EmptyState = ({ label, className = "" }) => (
  <div
    className={cx(
      "rounded-2xl border border-dashed border-slate-200 bg-slate-50 px-4 py-8 text-center text-sm text-slate-500",
      className
    )}
  >
    {label}
  </div>
);

export default EmptyState;
